export const storageKeys = {
  fen: 'fen',
  language: 'language',
  schoolId: 'coachSchoolId',
  tokenAccess: 'tokenAccess',
  tokenRefresh: 'tokenRefresh',
  tokenSetTime: 'tokenSetTime',
};
